const dataOffersEnEn = [
  {
    offer: 'FIBRE_VITAL',
    children: [
      {
        title: 'Internet Fibre',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Internet illimité</b></div>
            <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
            <div class="listing-item"><b>1 e-mail sécurisé</b></div>
            <div class="listing-item">
              <b>NordnetBox Wi-Fi&nbsp;6</b>
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Internet illimité</b></div>
            <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
            <div class="listing-item"><b>1 e-mail sécurisé</b></div>
            <div class="listing-item">
              <b>NordnetBox Wi-Fi&nbsp;6</b>
            </div>
          </div>`,
        customizedClass: 'nn-fibre nn-fibre-vital nn-internet',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>
        `,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>`,
        customizedClass: 'fibre nn-fibre-vital nn-phone',
      },
      {
        title: 'Assistance en ligne',
        icon: 'message-black-24.svg',
        contentOdil: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div> `,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'FIBRE_IDEAL',
    children: [
      {
        title: 'Internet Fibre',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Internet illimité</b></div>
          <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Internet illimité</b></div>
          <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
        </div>`,
        customizedClass: 'fibre nn-fibre-ideal nn-internet',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
          de France métropolitaine<br/>
          +&nbsp;50 destinations</div>
          <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
          de France métropolitaine<br/>
          +&nbsp;8 destinations</div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Appels illimités vers les fixes</b><br />
          de France métropolitaine<br />
          +&nbsp;50 destinations</div>
          <div class="listing-item"><b>Appels illimités vers les mobiles</b> <br />
          de France métropolitaine<br />
          +&nbsp;8 destinations</div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 30&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Réseau 4G Orange</b></div>
          <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
          <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Réseau 4G Orange</b></div>
          <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
          <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
          </div>
        </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'FIBRE_ULTRA',
    children: [
      {
        title: 'Internet Fibre',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Internet illimité</b></div>
          <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>Coach Wi-Fi&nbsp;:</b> accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Internet illimité</b></div>
          <div class="listing-item"><b>Débit jusqu'à 1&nbsp;Gb/s</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>Coach Wi-Fi&nbsp;:</b> accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            <b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations
          </div>
          <div class="listing-item">
            <b>Appels illimités vers les mobiles</b><br/>
            de France métropolitaine<br/>
            +&nbsp;8 destinations
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            <b>Appels illimités vers les fixes</b><br />
            de France métropolitaine<br />
            +&nbsp;50 destinations</div>
          <div class="listing-item">
            <b>Appels illimités vers les mobiles</b><br />
            de France métropolitaine<br />
            +&nbsp;8 destinations</div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 100&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
          <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
          <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
          <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
          <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'WiBox.tv <br/>(2 écrans en simultané)',
        icon: 'tv-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Plus de 100 chaînes TV</div>
          <div class="listing-item">Décodeur sous Android&trade; TV</div>
          <div class="listing-item">
            2<sup>nd</sup> Décodeur sous Android&trade; TV sur demande 
            (pour visualiser vos programmes sur un 2<sup>nd</sup> téléviseur)
          </div>
          <div class="listing-item">
            <b>Jusqu'à 80 heures d'enregistrement</b> de programmes dans le Cloud 
            (=informatique en nuage)
          </div>
          <div class="listing-item">
            <b>Boutique d'applications&nbsp;: </b><br/>
            streaming vidéo,  musique, replay, jeux, actu...
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Plus de 100 chaînes TV</div>
          <div class="listing-item">Décodeur sous Android&trade; TV</div>
          <div class="listing-item">
            2<sup>nd</sup> Décodeur sous Android&trade; TV sur demande 
            (pour visualiser vos programmes sur un 2<sup>nd</sup> téléviseur)
          </div>
          <div class="listing-item">
            <b>Jusqu'à 80 heures d'enregistrement</b> de programmes dans le Cloud 
            (=informatique en nuage)
          </div>
          <div class="listing-item">
            <b>Boutique d'applications&nbsp;:</b> <br />
            streaming vidéo,  musique, replay, jeux, actu...
          </div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Suite de sécurité Securitoo',
        icon: 'shield-virus-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Protégez jusqu'à 5 appareils<br/>
            (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Protégez jusqu'à 5 appareils<br />
            (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)
          </div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Presse',
        icon: 'press-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Plus de 1000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Plus de 1000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés
          </div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance premium',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
          </div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
          </div>
        </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_VITAL',
    children: [
      {
        title: 'Internet par Satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
                <div class="bolder"><b>+&nbsp;75&nbsp;Go</b> de trafic priorisé</div>
                <div class="anchor-target">pour passer devant les autres utilisateurs</div>
            </div>
            <div class="listing-item"><b>Débits jusqu'à 50&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item">
              <b>NordnetBox Wi-Fi&nbsp;6</b>
            </div>
            <div class="listing-item"><b>1 e-mail sécurisé</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <button id="toggle-vital-internet-details" class="anchor">
                  <b>+&nbsp;75&nbsp;Go</b> de trafic priorisé
              </button>
              <div class="anchor-target">pour passer devant les autres utilisateurs </div>
            </div>
            <div class="listing-item"><b>Débits jusqu'à 50&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item">
                <b>NordnetBox Wi-Fi&nbsp;6</b>
            </div>
            <div class="listing-item"><b>1 e-mail sécurisé</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>`,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance digitale',
        icon: 'message-black-24.svg',
        contentOdil: `
        <div class=icon-inline--text_text listing>
          <div class=listing-item>
              Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance
          </div>
        </div>`,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>
              Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance
            </div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_IDEAL',
    children: [
      {
        title: 'Internet par Satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Internet <b>illimité</b></div>
          <div class="listing-item">
              <div class="bolder"><b>+&nbsp;100&nbsp;Go</b> de trafic priorisé</div>
              <div class="anchor-target">pour passer devant les autres utilisateurs</div>
          </div>
          <div class="listing-item"><b>Débits jusqu'à 75&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Internet <b>illimité</b></div>
          <div class="listing-item">
            <button id="toggle-ideal-internet-details" class="anchor">
              <b>+&nbsp;100&nbsp;Go</b> de trafic priorisé
            </button>
            <div class="anchor-target">pour passer devant les autres utilisateurs </div>
          </div>
          <div class="listing-item"><b>Débits jusqu'à 75&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
        </div>
        `,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations</div>
            <div class="listing-item">
              <b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>Appels illimités vers les fixes</b><br />
              de France métropolitaine<br />
              +&nbsp;50 destinations
            </div>
            <div class="listing-item">
              <b>Appels illimités vers les mobiles</b><br />
              de France métropolitaine<br />
              +&nbsp;8 destinations
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 30&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités</b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'message-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Contactez-nous par téléphone, par e-mail, via la web-messagerie, 
              votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Contactez-nous par téléphone, par e-mail, via la web-messagerie, 
              votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ULTRA',
    children: [
      {
        title: 'Internet par Satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Internet <b>illimité</b></div>
          <div class="listing-item">
              <div class="bolder"><b>+&nbsp;150&nbsp;Go</b> de trafic priorisé</div>
              <div class="anchor-target">pour passer devant les autres utilisateurs</div>
          </div>
          <div class="listing-item"><b>Débits jusqu'à 100&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
          <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
          <div class="listing-item"><b>Coach Wi-Fi&nbsp;:</b> accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
          <div class="listing-item"><b>6 e-mails sécurisés</b></div>
        </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <button id="toggle-ultra-internet-details" class="anchor">
                <b>+&nbsp;150&nbsp;Go</b> de trafic priorisé
              </button>
              <div class="anchor-target">pour passer devant les autres utilisateurs </div>
            </div>
            <div class="listing-item"><b>Débits jusqu'à 100&nbsp;Mb/s&nbsp;↓ et 5&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Coach Wi-Fi&nbsp;:</b> accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations
            </div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations
            </div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 100&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'TV par Satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Tête TV compatible TNT SAT</div>
            <div class="listing-item">Décodeur TNT HD par Satellite<br/>(carte TNT Sat fournie)</div>
            <div class="listing-item">Enregistreur numérique<br/>(disque dur 1&nbsp;To fourni)</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Tête TV compatible TNT SAT</div>
            <div class="listing-item">Décodeur TNT HD par Satellite <br />(carte TNT Sat fournie)</div>
            <div class="listing-item">Enregistreur numérique <br />(disque dur 1&nbsp;To fourni)</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Presse',
        icon: 'press-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Plus de 1000 titres de presse accessibles en illimité, partout, 
              sur tous vos appareils connectés
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Plus de 1000 titres de presse accessibles en illimité, partout, 
              sur tous vos appareils connectés
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Suite de sécurité Securitoo',
        icon: 'shield-virus-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Protégez jusqu'à 5 appareils<br/>
            (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)
          </div>
        </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
            Protégez jusqu'à 5 appareils<br />
            (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Interruption',
        icon: 'power-off-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Suspension possible de l'abonnement une fois par an, pour une durée 
              de 1 mois à 6 mois, en cas d'absence.
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Suspension possible de l'abonnement une fois par an, pour une durée 
              de 1 mois à 6 mois, en cas d'absence.
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance premium',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> 
              (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client 
              ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> 
              (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client 
              ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: '&Eacute;changes zen',
        icon: 'pic_zen.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'R&eacute;siliation sans frais',
        icon: 'piggy-bank-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>La fibre arrive&nbsp;? <br />Changez d’offre quand vous voulez</b> (sans frais de résiliation anticipée -&nbsp;hors options&nbsp;-, quel que soit l’opérateur que vous choisirez)
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>La fibre arrive&nbsp;? <br />Changez d’offre quand vous voulez</b> (sans frais de résiliation anticipée -&nbsp;hors options&nbsp;-, quel que soit l’opérateur que vous choisirez)
            </div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: '4G_VITAL',
    children: [
      {
        title: 'Internet 4G',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item"><b>50&nbsp;Go de trafic mensuel</b></div>
          <div class="listing-item"><b>1 e-mail sécurisé</b></div>
          <div class="listing-item">
            <b>NordnetBox Wi-Fi&nbsp;6</b>
          </div>
        </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>50&nbsp;Go de trafic mensuel</b></div>
            <div class="listing-item"><b>1 e-mail sécurisé</b></div>
            <div class="listing-item">
                <b>NordnetBox Wi-Fi&nbsp;6</b>
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>`,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Appels facturés selon votre consommation</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance en ligne',
        icon: 'message-black-24.svg',
        contentOdil: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div>`,
        contentNordnet: `
          <div class=icon-inline--text_text listing>
            <div class=listing-item>Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: '4G_IDEAL',
    children: [
      {
        title: 'Internet 4G',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>90&nbsp;Go de trafic mensuel</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>90&nbsp;Go de trafic mensuel</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations
            </div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations
            </div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 30&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'message-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">
            Contactez-nous par téléphone, par e-mail, via la web-messagerie, 
            votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
          </div>
        </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Contactez-nous par téléphone, par e-mail, via la web-messagerie, 
              votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: '4G_ULTRA',
    children: [
      {
        title: 'Internet 4G',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>140&nbsp;Go de trafic mensuel</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Coach Wi-Fi&nbsp;: </b>accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
            <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Suspension possible de l'abonnement&nbsp;: </b>une fois par an en cas d'absence ou de baisse d'activité, pour une durée de 1 à 6 mois</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Débits jusqu'à 150&nbsp;Mb/s&nbsp;↓ et 30&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>140&nbsp;Go de trafic mensuel</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>Répéteur Wi-Fi&nbsp;6</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Coach Wi-Fi&nbsp;: </b>accompagnement personnalisé pour l'optimisation du Wi-Fi, partout chez vous, en fonction de votre besoin.</div>
            <div class="listing-item"><b>Galet Wi-Fi</b>&nbsp;(sur demande)</div>
            <div class="listing-item"><b>Suspension possible de l'abonnement&nbsp;: </b>une fois par an en cas d'absence ou de baisse d'activité, pour une durée de 1 à 6 mois</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b><br/>
              de France métropolitaine<br/>
              +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b><br/>
              de France métropolitaine<br/>
              +&nbsp;8 destinations</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 100&nbsp;Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G/&nbsp;5G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/MMS illimités </b></div>
            <div class="listing-item"><b>Internet mobile 100&nbsp;Go</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'WiBox.tv <br/>(2 écrans en simultané)',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Environ 40 chaînes TV incluses</div>
            <div class="listing-item">Décodeur sous Android&trade; TV</div>
            <div class="listing-item">2<sup>nd</sup> Décodeur sous Android&trade; TV sur demande (pour visualiser vos programmes sur un 2<sup>nd</sup> téléviseur)</div>
            <div class="listing-item"><b>Jusqu'à 80 heures d'enregistrement</b> de programmes dans le Cloud (=informatique en nuage)</div>
            <div class="listing-item"><b>Boutique d'applications&nbsp;: </b><br/>streaming vidéo,  musique, replay, jeux, actu...</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Environ 100 chaînes TV incluses</div>
            <div class="listing-item">Décodeur sous Android&trade; TV</div>
            <div class="listing-item">2<sup>nd</sup> Décodeur sous Android&trade; TV sur demande (pour visualiser vos programmes sur un 2<sup>nd</sup> téléviseur)</div>
            <div class="listing-item"><b>Jusqu'à 80 heures d'enregistrement</b> de programmes dans le Cloud (=informatique en nuage)</div>
            <div class="listing-item"><b>Boutique d'applications&nbsp;: </b><br /> streaming vidéo,  musique, replay, jeux, actu...</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Suite de sécurité Securitoo',
        icon: 'shield-virus-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils<br/>(Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils<br/>(Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android&trade; et iOS)</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Presse',
        icon: 'press-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Plus de 1000 titres de presse accessibles en illimité, partout, sur tous 
              vos appareils connectés
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Plus de 1000 titres de presse accessibles en illimité, partout, sur tous 
              vos appareils connectés
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Interruption',
        icon: 'power-off-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois 
              à 6 mois, en cas d'absence.
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois 
              à 6 mois, en cas d'absence.
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance premium',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b>
              (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client 
              ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b>
              (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client 
              ou le site d'Assistance, c'est vous qui choisissez&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: '&Eacute;changes zen',
        icon: 'pic_zen.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!
            </div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'R&eacute;siliation sans frais',
        icon: 'piggy-bank-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>La fibre arrive&nbsp;? <br />Changez d’offre quand vous voulez</b> (sans frais de résiliation anticipée -&nbsp;hors options&nbsp;-, quel que soit l’opérateur que vous choisirez)
            </div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">
              <b>La fibre arrive&nbsp;? <br />Changez d’offre quand vous voulez</b> (sans frais de résiliation anticipée -&nbsp;hors options&nbsp;-, quel que soit l’opérateur que vous choisirez)
            </div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ULTRA_PLUS',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
                <div class="bolder"><b>+&nbsp;200&nbsp;Go</b> de trafic priorisé</div>
                <div class="anchor-target">pour passer devant les autres utilisateurs</div>
            </div>
            <div class="listing-item"><b>Débits jusqu'à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
            <div class="listing-item"><b>Répéteur <span class="white-space">Wi-Fi&nbsp;6</span></b>&nbsp;(inclus sur demande)</div>
            <div class="listing-item"><b>Galet <span class="white-space">Wi-Fi</span></b>&nbsp;(inclus sur demande)</div>
            <div class="listing-item"><b>Coach <span class="white-space">Wi-Fi</span>&nbsp;:</b> accompagnement personnalisé pour l'optimisation du <span class="white-space">Wi-Fi</span>, partout chez vous, en fonction de votre besoin.</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <button id="toggle-ultra-internet-details" class="anchor">
                <b>+&nbsp;200&nbsp;Go</b> de trafic priorisé
              </button>
              <div class="anchor-target">pour passer devant les autres utilisateurs </div>
            </div>
            <div class="listing-item"><b>Débits jusqu'à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
            <div class="listing-item"><b>Répéteur <span class="white-space">Wi-Fi&nbsp;6</span></b>&nbsp;(inclus sur demande)</div>
            <div class="listing-item"><b>Galet <span class="white-space">Wi-Fi</span></b>&nbsp;(inclus sur demande)</div>
            <div class="listing-item"><b>Coach <span class="white-space">Wi-Fi</span>&nbsp;:</b> accompagnement personnalisé pour l'optimisation du <span class="white-space">Wi-Fi</span>, partout chez vous, en fonction de votre besoin.</div>
            <div class="listing-item"><b>6 e-mails sécurisés</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
        <ul class="icon-inline--text_text listing">
          <li class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine <br />+&nbsp;50 destinations</li>
          <li class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine <br />+&nbsp;8 destinations</li>
        </ul>`,
        contentNordnet: `
        <ul class="icon-inline--text_text listing">
          <li class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine <br />+&nbsp;50 destinations</li>
          <li class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine <br />+&nbsp;8 destinations</li>
        </ul>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 100 Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item"><b>Réseau 4G/ 5G Orange</b></li>
            <li class="listing-item"><b>Appels et SMS/ MMS illimités</b></li>
            <li class="listing-item"><b>Internet mobile 100&nbsp;Go</b></li>
          </ul>`,
        contentNordnet: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item"><b>Réseau 4G/ 5G Orange</b></li>
            <li class="listing-item"><b>Appels et SMS/ MMS illimités</b></li>
            <li class="listing-item"><b>Internet mobile 100&nbsp;Go</b></li>
          </ul>`,
        customizedClass: '',
      },
      {
        title: 'TV par satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item">Bride et tête TV FRANSAT</li>
            <li class="listing-item">Décodeur TV FRANSAT</li>
            <li class="listing-item">Enregistreur numérique <br />(disque dur 1&nbsp;To fourni)</li>
          </ul>`,
        contentNordnet: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item">Bride et tête TV FRANSAT</li>
            <li class="listing-item">Décodeur TV FRANSAT</li>
            <li class="listing-item">Enregistreur numérique <br />(disque dur 1&nbsp;To fourni)</li>
          </ul>`,
        customizedClass: '',
      },
      {
        title: 'Presse avec Cafeyn',
        icon: 'press-black-16.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Plus de 1&nbsp;000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés.</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Plus de 1&nbsp;000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés.</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Suite de sécurité Securitoo',
        icon: 'shield-halved-black-16.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android™ et iOS).</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android™ et iOS).</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Interruption',
        icon: 'power-off-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois à 6 mois, en cas d'absence.</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois à 6 mois, en cas d'absence.</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance Premium',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez !</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez !</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Échanges zen',
        icon: 'pic_zen.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Résiliation sans frais',
        icon: 'piggy-bank-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item"><b>La fibre arrive&nbsp;?</b><br>Changez d’offre (voire d'opérateur) quand vous voulez, si vous le souhaitez.<br><b>Pas de frais de résiliation anticipée</b> –&nbsp;hors options&nbsp;–, quelle que soit votre décision.</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item"><b>La fibre arrive&nbsp;?</b><br>Changez d’offre (voire d'opérateur) quand vous voulez, si vous le souhaitez.<br><b>Pas de frais de résiliation anticipée</b> –&nbsp;hors options&nbsp;–, quelle que soit votre décision.</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_IDEAL_PLUS',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <ul class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
                <div class="bolder"><b>+&nbsp;150&nbsp;Go</b> de trafic priorisé</div>
                <div class="anchor-target">pour passer devant les autres utilisateurs</div>
            </div>
            <div class="listing-item"><b>Débits jusqu’à 150&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
            <div class="listing-item"><b>Galet <span class="white-space">Wi-Fi</span></b> (inclus sur demande)</div>
            <div class="listing-item"><b>6 adresses e-mail sécurisées</b> par un antispam et un antivirus de messagerie</div>
          </ul>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <button id="toggle-ideal-internet-details" class="anchor">
                <b>+&nbsp;150&nbsp;Go</b> de trafic priorisé
              </button>
              <div class="anchor-target">pour passer devant les autres utilisateurs </div>
            </div>
            <div class="listing-item"><b>Débits jusqu’à 150&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
            <div class="listing-item"><b>Galet <span class="white-space">Wi-Fi</span></b> (inclus sur demande)</div>
            <div class="listing-item"><b>6 adresses e-mail sécurisées</b> par un antispam et un antivirus de messagerie</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Forfait mobile 30 Go',
        icon: 'mobile-signal-out-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/ MMS illimités</b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Réseau 4G Orange</b></div>
            <div class="listing-item"><b>Appels et SMS/ MMS illimités</b></div>
            <div class="listing-item"><b>Internet mobile 30&nbsp;Go</b></div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_VITAL_PLUS',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Internet <b>illimité</b></div>
          <div class="listing-item">
              <div class="bolder"><b>+&nbsp;100&nbsp;Go</b> de trafic priorisé</div>
              <div class="anchor-target">pour passer devant les autres utilisateurs</div>
          </div>
          <div class="listing-item"><b>Débits jusqu’à 100&nbsp;Mb/s&nbsp; ↓ et 10&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item">
            <b>NordnetBox Wi-Fi&nbsp;6</b>
          </div>
          <div class="listing-item"><b>1 adresse e-mail sécurisée</b> par un antispam et un antivirus de messagerie</div>
        </div>`,
        contentNordnet: `
        <div class="icon-inline--text_text listing">
          <div class="listing-item">Internet <b>illimité</b></div>
          <div class="listing-item">
            <button id="toggle-vital-internet-details" class="anchor">
              <b>+&nbsp;100&nbsp;Go</b> de trafic priorisé
            </button>
            <div class="anchor-target">pour passer devant les autres utilisateurs </div>
          </div>
          <div class="listing-item"><b>Débits jusqu’à 100&nbsp;Mb/s&nbsp; ↓ et 10&nbsp;Mb/s&nbsp;↑</b></div>
          <div class="listing-item">
            <b>NordnetBox Wi-Fi&nbsp;6</b>
          </div>
          <div class="listing-item"><b>1 adresse e-mail sécurisée</b> par un antispam et un antivirus de messagerie</div>
        </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Appels facturés selon votre consommation</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Appels facturés selon votre consommation</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance digitale',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous via la web-messagerie www.nordnet.com, votre Espace Client ou le site d'Assistance</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_PRO_PLUS',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <div class="bolder"><b>+&nbsp;500&nbsp;Go</b> de trafic priorisé</div>
              <div class="anchor-target">pour passer devant les autres utilisateurs</div>
            </div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>Adresse IP fixe</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b> </div>
            <div class="listing-item"><b>Galet Wi-Fi</b> (inclus sur demande)</div>
            <div class="listing-item"><b>20 adresses e-mail sécurisées</b> par un antispam et un antivirus de messagerie</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item">
              <button id="toggle-ideal-internet-details" class="anchor">
                  <b>+&nbsp;500&nbsp;Go</b> de trafic priorisé
              </button>
              <div class="anchor-target">pour passer devant les autres utilisateurs </div>
            </div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>Adresse IP fixe</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b> </div>
            <div class="listing-item"><b>Galet Wi-Fi</b> (inclus sur demande)</div>
            <div class="listing-item"><b>20 adresses e-mail sécurisées</b> par un antispam et un antivirus de messagerie</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</li>
            <li class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</li>
          </ul>`,
        contentNordnet: `
          <ul class="icon-inline--text_text listing">
            <li class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</li>
            <li class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</li>
          </ul>`,
        customizedClass: '',
      },
      {
        title: 'Presse avec Cafeyn',
        icon: 'press-black-16.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Plus de 1&nbsp;000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés.</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Plus de 1&nbsp;000 titres de presse accessibles en illimité, partout, sur tous vos appareils connectés.</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Suite de sécurité Securitoo',
        icon: 'shield-halved-black-16.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android™ et iOS).</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Protégez jusqu'à 5 appareils (Ordinateurs sous Windows ou macOS, tablettes et mobiles sous Android™ et iOS).</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Interruption',
        icon: 'power-off-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois à 6 mois, en cas d'absence.</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Suspension possible de l'abonnement une fois par an, pour une durée de 1 mois à 6 mois, en cas d'absence.</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Assistance premium',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bénéficiez de l'<b>assistance technique prioritaire par téléphone</b> (grâce à un numéro spécial), par e-mail, la web-messagerie, votre Espace Client ou le site d'Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Échanges zen',
        icon: 'pic_zen.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Recevez les matériels sans attendre la réception des pièces usagées, à nos frais&nbsp;!</div>
          </div>`,
        customizedClass: '',
      },
      {
        title: 'Résiliation sans frais',
        icon: 'piggy-bank-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item"><b>La fibre arrive&nbsp;?</b><br><b>Changez d’offre quand vous voulez</b></br> (sans frais de résiliation anticipée -&nbsp;hors options et frais fixes éventuels&nbsp;-, quel que soit l’opérateur que vous choisirez)</div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item"><b>La fibre arrive&nbsp;?</b><br><b>Changez d’offre quand vous voulez</b></br> (sans frais de résiliation anticipée -&nbsp;hors options et frais fixes éventuels&nbsp;-, quel que soit l’opérateur que vous choisirez)</div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ORANGE',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>1 adresse e-mail sécurisée</b></div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d’Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'TV par satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bride et tête TV FRANSAT</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ORANGE_PRO',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>1 adresse e-mail sécurisée</b></div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d’Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'TV par satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bride et tête TV FRANSAT</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ORANGE_2025',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>1 adresse e-mail sécurisée</b></div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d’Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'TV par satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bride et tête TV FRANSAT</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ORANGE_PRO_2025',
    children: [
      {
        title: 'Internet par satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item">Internet <b>illimité</b></div>
            <div class="listing-item"><b>Débits jusqu’à 200&nbsp;Mb/s&nbsp;↓ et 15&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox Wi-Fi&nbsp;6</b></div>
            <div class="listing-item"><b>1 adresse e-mail sécurisée</b></div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Téléphonie fixe',
        icon: 'phone-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Appels illimités vers les fixes</b> de France métropolitaine +&nbsp;50 destinations</div>
            <div class="listing-item"><b>Appels illimités vers les mobiles</b> de France métropolitaine +&nbsp;8 destinations</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'Assistance tous canaux',
        icon: 'user-headset-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Contactez-nous par téléphone, par e-mail, via la web-messagerie, votre Espace Client ou le site d’Assistance, c'est vous qui choisissez&nbsp;!</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
      {
        title: 'TV par satellite',
        icon: 'tv-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing without-listing">
            <div class="listing-item">Bride et tête TV FRANSAT</div>
          </div>`,
        contentNordnet: '',
        customizedClass: '',
      },
    ],
  },
  {
    offer: 'SAT_ORANGE_BE',
    children: [
      {
        title: 'Internet by satellite',
        icon: 'globe-web-black-24.svg',
        contentOdil: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Unlimited</b> Internet</div>
            <div class="listing-item"><b>Up to 200&nbsp;Mb/s&nbsp;↓ and 10&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
          </div>`,
        contentNordnet: `
          <div class="icon-inline--text_text listing">
            <div class="listing-item"><b>Unlimited</b> Internet</div>
            <div class="listing-item"><b>Up to 200&nbsp;Mb/s&nbsp;↓ and 10&nbsp;Mb/s&nbsp;↑</b></div>
            <div class="listing-item"><b>NordnetBox <span class="white-space">Wi-Fi&nbsp;6</span></b></div>
          </div>`,
        customizedClass: '',
      },
    ],
  },
];

export default dataOffersEnEn;
